import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MyAuthService } from '../../authentication/auth.service';
import { SharedService } from '../../services/shared.service';
import { ApiService } from '../../services/api.service';
@Component({
  selector: 'app-mobile-verify',
  templateUrl: './mobile-verify.component.html',
  styleUrls: ['./mobile-verify.component.scss']
})
export class MobileVerifyComponent implements OnInit {
  @Output() hideVerifyMobile = new EventEmitter<boolean>();
  public userInfo: any;
  public show = false;
  public verifyMobileForm: FormGroup;
  public verifyOtpForm: FormGroup;
  public isSubmitted = false;
  public isotpSubmitted = false;
  public showCloseBtn = true;
  public successMsg = 'Your Mobile number is verified successfully!';
  constructor(public formBuilder: FormBuilder,
    private _auth: MyAuthService,
    private _shared: SharedService,
    private _api: ApiService) {
    this._auth.userData.subscribe(userInfo => {
      this.userInfo = userInfo;
    });
  }

  ngOnInit() {
    console.log('email---', this._shared.subscribedEmail);
    if (this._shared.subscribedEmail !== '' && this._shared.subscribedEmail !== null) {
      console.log('showclose false');
      this.showCloseBtn = false;
    }
    if (this.userInfo && this.userInfo.identity.role === 2 && !this.userInfo.identity.mobile_confirmed) {
      this.showCloseBtn = false;
    }
    console.log(this.userInfo, this.showCloseBtn);
  }

  close() {
    // console.log('closemodal')
    // this.hideVerifyMobile.emit(false);
    this._shared.toggleMobileVerify(null);
  }

}
